/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LocationContext } from './LocationContext';
import {
    LocationContextFromJSON,
    LocationContextFromJSONTyped,
    LocationContextToJSON,
    LocationContextToJSONTyped,
} from './LocationContext';

/**
 * 
 * @export
 * @interface SetReferenceAndNotesRequest
 */
export interface SetReferenceAndNotesRequest {
    /**
     * 
     * @type {string}
     * @memberof SetReferenceAndNotesRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {LocationContext}
     * @memberof SetReferenceAndNotesRequest
     */
    locationContext: LocationContext;
    /**
     * Carrier-facing reference. For an Amazon distribution-warehouse delivery, supply amazonReferenceId and amazonShipmentId instead - the server packs them into this reference. If both routes are supplied, they must match
     * @type {string}
     * @memberof SetReferenceAndNotesRequest
     */
    reference?: string;
    /**
     * Amazon Reference ID. Only valid with locationContext 'delivery' when the delivery is to an Amazon distribution warehouse; required then, along with amazonShipmentId
     * @type {string}
     * @memberof SetReferenceAndNotesRequest
     */
    amazonReferenceId?: string;
    /**
     * Amazon Shipment ID. Only valid with locationContext 'delivery' when the delivery is to an Amazon distribution warehouse; required then, along with amazonReferenceId
     * @type {string}
     * @memberof SetReferenceAndNotesRequest
     */
    amazonShipmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof SetReferenceAndNotesRequest
     */
    notes: string;
    /**
     * 
     * @type {string}
     * @memberof SetReferenceAndNotesRequest
     */
    boothNumber: string;
}



/**
 * Check if a given object implements the SetReferenceAndNotesRequest interface.
 */
export function instanceOfSetReferenceAndNotesRequest(value: object): value is SetReferenceAndNotesRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('locationContext' in value) || value['locationContext'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('boothNumber' in value) || value['boothNumber'] === undefined) return false;
    return true;
}

export function SetReferenceAndNotesRequestFromJSON(json: any): SetReferenceAndNotesRequest {
    return SetReferenceAndNotesRequestFromJSONTyped(json, false);
}

export function SetReferenceAndNotesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetReferenceAndNotesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'locationContext': LocationContextFromJSON(json['locationContext']),
        'reference': json['reference'] == null ? undefined : json['reference'],
        'amazonReferenceId': json['amazonReferenceId'] == null ? undefined : json['amazonReferenceId'],
        'amazonShipmentId': json['amazonShipmentId'] == null ? undefined : json['amazonShipmentId'],
        'notes': json['notes'],
        'boothNumber': json['boothNumber'],
    };
}

  export function SetReferenceAndNotesRequestToJSON(json: any): SetReferenceAndNotesRequest {
      return SetReferenceAndNotesRequestToJSONTyped(json, false);
  }

  export function SetReferenceAndNotesRequestToJSONTyped(value?: SetReferenceAndNotesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'locationContext': LocationContextToJSON(value['locationContext']),
        'reference': value['reference'],
        'amazonReferenceId': value['amazonReferenceId'],
        'amazonShipmentId': value['amazonShipmentId'],
        'notes': value['notes'],
        'boothNumber': value['boothNumber'],
    };
}

